import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import { OfficeId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => {
  return {
    list: () =>
      queryOptions({
        queryKey: ["office-branches"],
        queryFn: () => api.get("./office_branches", {}),
      }),
    availableCounties: (officeId: OfficeId) =>
      queryOptions({
        queryKey: ["office-branches", "available-counties", officeId],
        queryFn: () =>
          api.get("./offices/:officeId/office_branches/available_counties", {
            path: { officeId },
          }),
      }),
  };
});
